import { useStrings } from "@1js/localization-components";
import { PromptTabs } from "@1js/pl-card-components";
import {
  Body1,
  Image,
  makeStyles,
  Subtitle1,
  tokens,
} from "@fluentui/react-components";
import React from "react";
import { useNavigate } from "react-router-dom";
import { readFromMetaTags } from "../../utils/Telemetry/config";
import {
  BrowseMicrosoftPromptsButton,
  NoAgentsPromptsHeading,
  NoAgentsPromptsSubHeading,
  NoGroupPromptsHeading,
  NoGroupPromptsSubHeading,
  NoLikedPromptsHeading,
  NoLikedPromptsSubHeading,
  NoSavedPromptsHeading,
  NoSavedPromptsSubHeading,
} from "./EmptyStatePromptResults.string";

export const useStyles = makeStyles({
  root: {
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "90px",
    gap: "9px",
    width: "100%",
    maxWidth: "536px",
    "@media (max-width: 600px) and (min-width: 361px)": {
      maxWidth: "350px",
    },
    "@media (max-width: 360px)": {
      maxWidth: "250px",
    },
  },
  button: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    width: "256px",
    borderRadius: "4px",
    paddingLeft: "6px",
    paddingRight: "6px",
    paddingTop: "12px",
    paddingBottom: "12px",
    justifyContent: "center",
  },
  buttonContainer: {
    paddingTop: "28px",
    textAlign: "center",
  },
});

type EmptyStatePromptResultsProps = {
  navItem: string;
};

export const EmptyStatePromptResults: React.FC<
  EmptyStatePromptResultsProps
> = ({ navItem }) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const localizations = useStrings({
    NoAgentsPromptsHeading,
    NoAgentsPromptsSubHeading,
    BrowseMicrosoftPromptsButton,
    NoGroupPromptsHeading,
    NoGroupPromptsSubHeading,
    NoLikedPromptsHeading,
    NoLikedPromptsSubHeading,
    NoSavedPromptsHeading,
    NoSavedPromptsSubHeading,
  });

  const getNoResultHeading = () => {
    switch (navItem) {
      case PromptTabs.AgentPrompts:
        return localizations.NoAgentsPromptsHeading();
      case PromptTabs.GroupPrompts:
        return localizations.NoGroupPromptsHeading();
      case PromptTabs.SavedPrompts:
        return localizations.NoSavedPromptsHeading();
      case PromptTabs.LikedPrompts:
        return localizations.NoLikedPromptsHeading();
      default:
        return "";
    }
  };

  const getNoResultSubHeading = () => {
    switch (navItem) {
      case PromptTabs.AgentPrompts:
        return localizations.NoAgentsPromptsSubHeading();
      case PromptTabs.GroupPrompts:
        return localizations.NoGroupPromptsSubHeading();
      case PromptTabs.SavedPrompts:
        return localizations.NoSavedPromptsSubHeading();
      case PromptTabs.LikedPrompts:
        return localizations.NoLikedPromptsSubHeading();
      default:
        return "";
    }
  };

  const handleClick = () => {
    navigate(
      `../microsoft?hostName=${readFromMetaTags("awa-hostName")}&hostClientType=${readFromMetaTags("awa-hostClientType")}`
    );
  };

  return (
    <div className={styles.root}>
      <Subtitle1 id="no-results-heading">{getNoResultHeading()}</Subtitle1>
      <Image
        src="https://copilot.cloud-dev.microsoft/images/EmptyStateCollection.webp"
        aria-labelledby="no-results-heading"
      />
      <Body1>
        {getNoResultSubHeading()}
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={handleClick}>
            {localizations.BrowseMicrosoftPromptsButton()}
          </button>
        </div>
      </Body1>
    </div>
  );
};
